function BlogKnowable({ blogHashtags }) {
  return (
    <div id="blogknow-img" className=" mx-0 mt-5 mb-3" style={{ padding: "10px 5%" }}>
      <div>
        <h4 className="pt-5 ps-5 mb-5 text-white">دوست دارید بیشتر راجب چه چیزی بدانید</h4>
        <div className="d-flex flex-wrap justify-content-center">
          {blogHashtags.map((value) => {
            return (
              <p className="blogknow text-center p-2 my-3 mx-4 bg-light rounded-10 pointer" style={{ width: "130px" }}>
                {value.txt}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default BlogKnowable;
